import React from 'react'
import Button from 'devextreme-react/button'
import { useMediaQuery } from '@react-hooks-library/core'

const Finish = () => {
  const isLargeScreen = useMediaQuery('(min-width: 640px)')

  return (
    <div className='animate__animated animate__fadeIn'>
      <h6 className='font-bold text-gray-600  md:mb-3 mb-2 xl:text-5xl md:text-4xl text-3xl'>
        ¡Gracias por diligenciar el formulario!
      </h6>
      <p className='text-gray-600 text-base xl:text-2xl md:text-xl sm:text-lg text-base mb-5'>
        Estaremos comunicándonos contigo en los próximos días.
      </p>

      <Button
        width={isLargeScreen ? 340 : '100%'}
        icon='arrowright'
        type='success' style={{
          backgroundColor: '#40c0c0'
        }} text='Ver proximos eventos de impacta' onClick={() => {
          window.location = 'https://impacta.emprendimientosostenible.com.co/conversatorios/'
        }}
      />

    </div>
  )
}

export default Finish
